module.exports = __webpack_public_path__ + "img/horizontal_3_1_r_pp1_9006.24ebd3d0.png";